Apt.fn.make('tab', {
	/**
	 * Initialize module
	 *
	 * @param {$} target
	 * @param {Function} [fn]
	 * @param {Boolean} [once=false]
	 */
	init(target, fn, once) {
		const scope = this;
		const sel = '.tab__item';
		const active = $(sel, target).filter('.-is-active');

		scope.fn = fn;
		scope.uid = LS.util.uid();

		if (once) {
			scope.fired = [];
		}

		// Initialize default selection
		if (active.length) {
			scope.select(active[0], true);
		}

		$.events.on(sel, 'mousedown', (e, el) => {
			scope.select(el);
		}, {
			break: true,
			delegate: target,
			namespace: scope.uid
		});

		return scope;
	},

	/**
	 * Set selection
	 *
	 * @param {$} el
	 * @param {Boolean} [init=false]
	 */
	select(el, init = false) {
		const scope = this;
		const controls = el.getAttribute('aria-controls');
		const id = el.dataset.id || controls;
		const activeClass = '-is-active';

		$(el).addClass(activeClass)
			.siblings()
			.removeClass(activeClass);

		if (controls) {
			$('#' + controls).show()
				.siblings('[role="tabpanel"]')
				.hide();
		}

		if (id) {
			if (scope.fired) {
				if (scope.fired.includes(id)) {
					return;
				}

				scope.fired.push(id);
			}

			if (scope.fn) {
				scope.fn(id, init);
			}
		}
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		$.events.reset(this.uid);
	}
});